<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Storywalk Frames and Bases"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          Durable frames and bases designed to display published storybook pages.
        </div><br>
        <div>Storywalk frames and bases provide an opportunity for children of all ages to enjoy reading a story
          while outdoors. Pages from a children’s storybook are laminated and installed along a path, such as in a
          garden or other environmental setting. This creative concept works to enhance the outdoor experience.
          Storywalk frames are designed to accommodate typical sizes of published books. You simply insert your
          own laminated pages in the frames. Pedestal posts and sleeves for wood posts are both available. When
          it’s time to change or update the story, the laminated pages are easily switched.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div><br>
        <div>
          <div>
            <h5>Storywalk Backer Sheets</h5>
            <div>Make creating your Storywalk layouts easier with Storywalk Backer Sheets.
              This thin, durable plastic allows you to tape your Storywalk images in place indoors, before installing in your frames.
              Cut to size and thin enough to be sandwich between your two sheets of Storywalk Frame acrylic.
              Consider getting an extra set so your frames are never left empty!</div>
          </div>
          <div style="text-align: center;">
            <div class="img" style="padding: 10px;">
              <img :src="require('@/assets/images/pages/story-walk/colors.png')" width="100%">
            </div>
            <div class="img">
              <img :src="require('@/assets/images/pages/story-walk/backer-image.png')" width="80%">
            </div>
          </div>
        </div>
        <hr>
        <div>
          <div>
            <h5>Storywalk SensoryPEN</h5>
            <div>Add audio to your Storywalk with <strong>SensoryPEN</strong>. Contact us at <a href="mailto:info@envirosigns.com">info@envirosigns.com</a> for details and pricing.</div>
          </div>
          <div style="text-align: center;">
            <div class="img" style="padding: 10px;">
              <img :src="require('@/assets/images/pages/story-walk/storywalk-sensorypen-prospect-heights-public-library.jpg')" width="100%">
            </div>
            <div class="img">
              <img :src="require('@/assets/images/pages/story-walk/sensorypen.jpg')" width="80%">
            </div>
          </div>
        </div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-8 col-lg-8 image-pod">
              <div class="img story-walk-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/story-walk/storywalk-frame-and-base.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-4 col-lg-4 image-pod">
              <div class="img story-walk-133-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/story-walk/storywalk-sign.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-3 col-lg-3 image-pod">
              <div class="img story-walk-157-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/story-walk/storywalk-sign-and-frame.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-9 col-lg-9 image-pod">
              <div class="img story-walk-50-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/story-walk/storywalk-frames-and-posts.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: `Storywalk Frames and Bases`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/StoryWalk.vue